import { Injectable } from '@angular/core';
import { UtilProvider } from "../util/util";

@Injectable()
export class DataProvider {
  private baseUrl = "https://svc.atollac.com/api/";

  public whenInit: Date = undefined;
  public whenPost: Date = undefined;

  constructor(public utilProvider: UtilProvider) {
    console.log("0");
  }

  authPost(cred) {
    if (cred.hashed == false) {
      cred.password = this.utilProvider.sha256_digest(cred.password);
    }

    sessionStorage.setItem("__crd__", JSON.stringify(cred));

    return fetch(this.baseUrl + "auth", {
      method: 'post',
      body: JSON.stringify(cred),
      headers: { "Content-Type": "application/json" }
    });
  };

  categoryGet(date) {
    let jwt = sessionStorage.getItem("__jwt__");
    let accountId = sessionStorage.getItem("__aid__");

    date = date || new Date();

    let year = date.getUTCFullYear();
    let month = date.getMonth();
    let offset = date.getTimezoneOffset();

    let url = this.baseUrl + "buckets/dashboard/" + accountId + "/" + year + "/" + month + "/" + offset;

    return fetch(url, {
      method: 'get',
      headers: { "Content-Type": "application/json", "Authorization": jwt }
    });
  };

  lookupsGet() {
    let jwt = sessionStorage.getItem("__jwt__");
    let accountId = sessionStorage.getItem("__aid__");
    let url = this.baseUrl + "lookups/" + accountId;

    return fetch(url, {
      method: 'get',
      headers: { "Content-Type": "application/json", "Authorization": jwt }
    });
  };

  entryPost(entry) {
    let jwt = sessionStorage.getItem("__jwt__");
    let url = this.baseUrl + "entrys";

    return fetch(url, {
      method: 'post',
      body: JSON.stringify(entry),
      headers: { "Content-Type": "application/json", "Authorization": jwt }
    });
  };

  entryDelete(id) {
    let jwt = sessionStorage.getItem("__jwt__");
    let url = this.baseUrl + "entrys/" + id;


    let xhr = new XMLHttpRequest();
    xhr.open("DELETE", url, true);

    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.setRequestHeader("Authorization", jwt);

    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4 && xhr.status == 200) {
        return true;
      }
    };

    xhr.send(null);
  };

  locationPost(location) {
    let jwt = sessionStorage.getItem("__jwt__");
    let url = this.baseUrl + "locations";

    return fetch(url, {
      method: 'post',
      body: JSON.stringify(location),
      headers: { "Content-Type": "application/json", "Authorization": jwt }
    });
  };

  userPost(user) {
    let jwt = sessionStorage.getItem("__jwt__");
    let url = this.baseUrl + "users";
    user.password = this.utilProvider.sha256_digest(user.Password);

    return fetch(url, {
      method: 'post',
      body: JSON.stringify(user),
      headers: { "Content-Type": "application/json", "Authorization": jwt }
    });
  };

  categoryPost(category) {
    let jwt = sessionStorage.getItem("__jwt__");
    let url = this.baseUrl + "categorys";

    return fetch(url, {
      method: 'post',
      body: JSON.stringify(category),
      headers: { "Content-Type": "application/json", "Authorization": jwt }
    });
  };
}


// WEBPACK FOOTER //
// ./src/providers/data/data.ts